import * as React from "react";
import * as yup from "yup";

import { Link } from "src/library/components/Link";
import {
  Form,
  IFormField
} from "src/library/components/Forms";
import Grid from "src/library/components/Hedron";

interface LoginFormProps {
  errorMessage: string | null;
  loggingIn: boolean;
  onSubmit: (username: string, password: string) => void;
}

const loginFormFields: IFormField[] = [
  {
    type: "input",
    name: "username",
    label: "Email",
    placeholder: "Email",
    validation: yup
      .string()
      .trim()
      .email()
      .strict(false)
      .required("Email is required")
  },
  {
    type: "input",
    name: "password",
    inputType: "password",
    label: "Password",
    placeholder: "Password",
    validation: yup
      .string()
      .min(1)
      .required("Password is required")
  }
];

export const LoginForm: React.FC<LoginFormProps> = ({
  errorMessage, loggingIn, onSubmit
}) => {
  return (
    <Form
      autoHideLabels
      error={errorMessage}
      submitting={loggingIn}
      fields={loginFormFields}
      onSubmit={({ username, password }) => onSubmit(username, password)}
      submitButtonText="Login"
      submitButtonAlignment="center"
    >
      <Grid.Bounds direction="horizontal">
        <Grid.Box shiftRight>
          <Link to="/forgot-password">
            Forgot Password
          </Link>
        </Grid.Box>
      </Grid.Bounds>
    </Form>
  );
};
